export default __webpack_public_path__ + "static/media/MaterialMetal_08.014ed686.png";